<template>
    <div>
        <Link as="div" :onStart="() => emits('navigate')" :href="props.list_item.seo_name != null ? route('productDetail.show', [props.list_item.seo_name]) : '#'" class="product-list-item">
            <img id="list_item_image" class="product-image bg-rothcoCream" :src="imgSrc" :alt="props.list_item.item_name" loading="lazy">
            <div class="product-item">
                <div id="list_item_title" class="product-item-name title-s">{{ props.list_item.item_name }}</div>
                <p id="list_item_item_no" class="product-item-id">#{{ props.list_item.rothco_item_no }}</p>
                <p id="list_item_updated_at" class="product-item-upd">Updated: {{ useDateFormat(props.list_item.activate_date, 'MM/DD/YYYY') }}</p>
            </div>
        </Link>
    </div>
</template>
<script lang="ts" setup>
    import { Link } from "@inertiajs/vue3";
    import { computed, inject } from "vue";
    import { useDateFormat } from "@vueuse/core";
    import { comingSoonImages } from "@/helpers/composables/comingSoonImages"
    
    let route = inject('route');
    let props = defineProps({
        list_item: {
            type: Object,
            required: true,
            default() {
                return {};
            }
        }
    });

    let emits = defineEmits(['navigate']);
    let imgSrc = computed(() => {
        return props.list_item.image_filename ? `${import.meta.env.VITE_APP_URL}/upload/product/product/large/${props.list_item.image_filename}`
            : comingSoonImages().small
    });
</script>
